// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicWebHomepage2B } from "./plasmic/o_21_p_0_0_2_prod/PlasmicWebHomepage2B";
import { Helmet } from "react-helmet-async";

function WebHomepage2B_(props, ref) {
  return (
        <>
          <Helmet>
            
          </Helmet>
    
          <PlasmicWebHomepage2B root={{ ref }} {...props} />
        </>
      );
}

const WebHomepage2B = React.forwardRef(WebHomepage2B_);

export default WebHomepage2B;
